import { Link } from "react-router-dom";
import type { GossipEvent } from "@/mocks/gossip";
import { siteStats } from "@/mocks/gossip";

export default function HeroSection({ event }: { event: GossipEvent }) {
  return (
    <section className="relative w-full overflow-hidden bg-background-50">
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.5]"
        style={{
          backgroundImage:
            "linear-gradient(oklch(var(--background-200)) 1px, transparent 1px), linear-gradient(90deg, oklch(var(--background-200)) 1px, transparent 1px)",
          backgroundSize: "72px 72px",
        }}
        aria-hidden="true"
      ></div>
      <div className="absolute -top-24 -left-24 w-[420px] h-[420px] rounded-full bg-accent-100/60 blur-3xl" aria-hidden="true"></div>

      <div className="relative w-full px-4 md:px-8 pt-10 md:pt-16 pb-12 md:pb-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          <div className="lg:col-span-6 xl:col-span-6">
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3.5 py-1.5 font-label text-xs text-primary-700">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
              本期深扒 · {event.category}
            </span>

            <h1 className="mt-5 font-heading font-black text-3xl sm:text-4xl md:text-5xl xl:text-[54px] leading-[1.15] text-foreground-950">
              {event.title}
            </h1>

            <p className="mt-5 font-label text-base md:text-lg leading-relaxed text-foreground-600 max-w-xl">
              {event.summary}
            </p>

            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <Link
                to={`/event/${event.id}`}
                className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 font-label text-sm text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-time-line text-base"></i>
                查看完整时间线
              </Link>
              <Link
                to="/events"
                className="inline-flex items-center justify-center gap-2 rounded-md border border-background-400 bg-background-50 px-6 py-3 font-label text-sm text-foreground-900 hover:border-primary-400 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                浏览全部复盘档案
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <dl className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-5">
              {siteStats.map((s) => (
                <div key={s.label}>
                  <dt className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
                    {s.value}
                  </dt>
                  <dd className="mt-1 font-label text-xs text-foreground-500">{s.label}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="lg:col-span-6 xl:col-span-6">
            <div className="relative">
              <div className="relative overflow-hidden rounded-lg border border-background-300 bg-background-200">
                <div className="w-full aspect-[4/3]">
                  <img
                    src={event.cover}
                    alt={`${event.title} 事件线索示意`}
                    className="w-full h-full object-top object-cover"
                  />
                </div>
                <div className="absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-black/35 to-transparent"></div>
                <div className="absolute top-4 left-4 flex items-center gap-2 rounded-md bg-background-50/90 px-3 py-1.5 font-label text-xs text-foreground-800">
                  <i className="ri-time-line text-primary-600"></i>
                  {event.timeline.length} 个时间节点已整理
                </div>
              </div>

              <div className="hidden sm:flex absolute -bottom-6 -left-6 flex-col gap-1 rounded-lg border border-background-200 bg-background-50 px-4 py-3 shadow-none">
                <span className="font-label text-[11px] text-foreground-500">时间线跨度</span>
                <span className="font-heading font-bold text-lg text-foreground-950">
                  {event.timeline[0].time} — {event.timeline[event.timeline.length - 1].time}
                </span>
              </div>

              <div className="hidden sm:flex absolute -top-5 -right-4 items-center gap-2 rounded-lg border border-background-200 bg-accent-500 px-4 py-3">
                <i className="ri-fire-fill text-lg text-accent-950"></i>
                <span className="flex flex-col leading-tight">
                  <span className="font-heading font-bold text-base text-accent-950">{event.heat}</span>
                  <span className="font-label text-[10px] text-accent-900">当前热度</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}